import { IDictionary, ReadonlyRecord } from '@bimser/core';
import { List, Map, Record } from 'immutable';
import { AlertType, DialogType } from '../Enums';
import { NodeLocationFactory, NodeLocationFactoryFromJS } from '../INodeLocation';
import { IBaseAction, ReadOnlyBaseAction } from './IBaseAction';

export interface IBaseValidationFailureAction {
	typeName: 'ValidationFailureAction';
	alertType: AlertType;
	dialogType: DialogType;
}

export interface IValidationFailureAction extends IBaseValidationFailureAction, IBaseAction {
	messages: IDictionary<string>;
	highlightList: Array<string>;
}

export interface ReadOnlyValidationFailureAction
	extends IBaseValidationFailureAction,
		ReadOnlyBaseAction {
	messages: Map<string, string>;
	highlightList: List<string>;
}

export type ValidationFailureAction = ReadonlyRecord<ReadOnlyValidationFailureAction>;

export const ValidationFailureActionFactory = Record<ReadOnlyValidationFailureAction>({
	alertType: null,
	dialogType: null,
	messages: null,
	highlightList: List(),
	typeName: 'ValidationFailureAction',
	id: null,
	name: null,
	loc: NodeLocationFactory()
});

export const ValidationFailureActionFactoryFromJS = (data: IValidationFailureAction) => {
	return ValidationFailureActionFactory({
		...data,
		messages: Map(data.messages),
		highlightList: List(data.highlightList),
		loc: data.loc ? NodeLocationFactoryFromJS(data.loc) : null
	});
};
